import React from 'react'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import Modal from '../common/Modal'

import withRouter from '../../lib/withRouter'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/Users'
import connectIndex from '../../lib/connectIndex'
import BrandReportsDisplay from '../common/BrandReportsDisplay'

export class CarrierUserIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    records: PropTypes.array,
    includeSearch: PropTypes.bool,
    flashMessages: PropTypes.array.isRequired,
    searchColumns: PropTypes.array,
    actionLinks: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    includeSearch: true,
    searchColumns: ['username', 'email'],
    actionLinks: []
  }

  static columns = [
    { key: 'username', label: 'Username' },
    { key: 'email', label: 'Email' },
    { key: 'carrier_brands', label: 'Carrier Brands', display: BrandReportsDisplay },
    { key: 'last_logged_in', label: 'Last Logged In' }
  ]

  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      modalMessage: ''
    }
  }

  get actionLinks() {
    let list = this.props.actionLinks
    list = list.concat(this.exportCsvButton)
    return list
  }

  get exportCsvButton() {
    const title = `CSV Export (${this.props.pagination ? this.props.pagination.total : ''})`
    return (
      <button
        key="csv-export"
        className="button quiet-button small"
        title={title}
        id="csv_export"
        onClick={this.handleCsvExportButton}
      >
        {title}
      </button>
    )
  }

  generateCsvContent = (columns, records) => {
    const header = `${columns.map((column) => column.label).join(',')}\n`
    const body = records.map((record) => columns.map(
      (column) => String(record[column.key])
    ).join(',')).join('\n')

    return header + body
  }

  fetchAllPages = async () => {
    const pagePromises = []
    const totalPages = this.props.pagination.pages
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const searchTerm = urlParams.get('search_term')

    for (let page = 1; page <= totalPages; page += 1) {
      pagePromises.push(this.props.index({ user_type: 'carrier', search_term: searchTerm, page }))
    }
    const pages = await Promise.all(pagePromises)
    const allRecords = pages.flatMap((page) => page.records)
    return allRecords
  }

  handleCsvExportButton = async () => {
    this.setState({ isModalOpen: true, modalMessage: 'Exporting Carrier Users... Please wait.' })

    const allRecords = await this.fetchAllPages()
    const transformedRecords = allRecords.map((record) => ({
      ...record,
      carrier_brands: record.carrier_brands.map((brand) => brand.name).join('; ')
    }))
    const csvContent = this.generateCsvContent(CarrierUserIndex.columns, transformedRecords)

    this.downloadCsv(csvContent, 'carrier_users.csv')
    this.closeModal()
  }

  closeModal = () => {
    this.setState({ isModalOpen: false, modalMessage: '' })
    setTimeout(() => window.location.reload(), 1000)
  }

  downloadCsv = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/carrier_users"
          name="Carrier User"
          pagination={this.props.pagination}
          columns={CarrierUserIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          includeSearch={this.props.includeSearch}
          searchColumns={this.props.searchColumns}
          additionalQueryParams={['user_type']}
          extraQueryParams={{ user_type: 'carrier' }}
          actionLinks={this.actionLinks}
          history={this.props.history}
        />
        {this.state.isModalOpen && <Modal onClose={this.closeModal}><p>{this.state.modalMessage}</p></Modal>}
      </div>
    )
  }
}

export default connectIndex(withRouter(CarrierUserIndex), 'users', actions)
